import { useEffect, useState } from 'react'

export function useCoachingString(
  coachingId: string | null,
  read: (coachingId: string) => Promise<string | null>,
  enabled = true,
) {
  const [value, setValue] = useState<string | null | undefined>(undefined)
  useEffect(() => {
    let cancelled = false
    setValue(undefined)
    if (!coachingId) {
      setValue(null)
      return
    }
    if (!enabled) return
    read(coachingId)
      .then((value) => { if (!cancelled) setValue(value) })
      .catch(() => { if (!cancelled) setValue(null) })
    return () => { cancelled = true }
  }, [coachingId, read, enabled])
  return [value, setValue] as const
}
